import { createElementBlock as l, openBlock as a, createElementVNode as e } from "vue";
import t from "./index289.js";
const c = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function r(s, o, f, i, p, d) {
  return a(), l("svg", n, o[0] || (o[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#FFF9D5",
        d: "M41.551 18.474c6.404 6.532 6.404 17.122 0 23.654a16.17 16.17 0 0 1-23.19 0c-6.403-6.532-6.403-17.122 0-23.654a16.17 16.17 0 0 1 23.19 0"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M5.5 16.75c.647 0 1.18.492 1.244 1.122L6.75 18v.25H7a1.25 1.25 0 0 1 .128 2.494L7 20.75h-.25V21a1.25 1.25 0 0 1-2.494.128L4.25 21v-.25H4a1.25 1.25 0 0 1-.128-2.494L4 18.25h.25V18c0-.69.56-1.25 1.25-1.25Zm46.486 27.58c.647 0 1.18.491 1.243 1.121l.007.128v2.25h2.25a1.25 1.25 0 0 1 .128 2.494l-.128.006h-2.25v2.25a1.25 1.25 0 0 1-2.494.128l-.006-.128v-2.25h-2.25a1.25 1.25 0 0 1-.128-2.493l.128-.007h2.25v-2.25c0-.69.56-1.25 1.25-1.25ZM42.444 17.6c6.88 7.017 6.88 18.385 0 25.403a17.42 17.42 0 0 1-24.975 0c-6.88-7.018-6.88-18.386 0-25.404a17.42 17.42 0 0 1 24.975 0Zm-23.19 1.75c-5.927 6.045-5.927 15.857 0 21.903a14.92 14.92 0 0 0 21.405 0c5.84-5.959 5.926-15.574.254-21.639l-.254-.265-.256-.255a14.918 14.918 0 0 0-21.149.255ZM12.5 4.75c.647 0 1.18.492 1.244 1.122L13.75 6v1.25H15a1.25 1.25 0 0 1 .128 2.494L15 9.75h-1.25V11a1.25 1.25 0 0 1-2.494.128L11.25 11V9.75H10a1.25 1.25 0 0 1-.128-2.494L10 7.25h1.25V6c0-.69.56-1.25 1.25-1.25Z"
      })
    ], -1)
  ]));
}
const v = /* @__PURE__ */ t(c, [["render", r]]);
export {
  v as default
};
